<div class="stb-scheduling" *ngIf="vm.scheduleLoaded">
	<div style="min-height:60px;">
	    <div style="top: 0px !important;" class="fc-button-group fc custom-buttons configure">
	        <button style="top: 15px !important;" class="fc-button reserved-time-button" id="openReserveTimeDialogButton" (click)="vm.openReserveTimeDialog()">
	            {{ 'Booking.Modal.AddReservedTime' | translate }}
	        </button>
	    </div>
	</div>
    <div style="display: flex; justify-content: center; align-items: center; gap: 16px; padding: 0 16px"
         *ngIf="!vm.googleCalendarFeatureDisabled && vm.googleCalendarIntegrated">
        <p class="c-text" style="margin-top: 16px; color: text;">{{ vm.getLastSynchronizationDate() }}</p>
        <button style="margin-top: 15px;" class="c-button c-button--s1" id="synchronizeButton" (click)="vm.synchronize()">
            {{ 'Calendar.Button.Configure' | translate }}
        </button>
        <div style="margin-top: 12px">
            <synchronize-calendar-info-popover placement="right"
                                               placementMobile="top"
                                               [wrapperMobile]="vm.popoverMobileWrapper"
                                               (click)="$event.preventDefault()"
                                               style="vertical-align:middle">
            </synchronize-calendar-info-popover>
        </div>
    </div>
    <md-card class="stb-scheduling" *ngIf="vm.eventsFetched">
        <h3 style="min-height:40px;">{{ 'Calendar.Title.Schedule' | translate }}</h3>
        <div class="calendar-legend" style="margin-top: 4px;">
            <div class="legend-item">
                <span class="legend-color legend-yellow"></span>
                <span class="legend-text"> - {{ 'Calendar.Other.Delay_Time' | translate }}</span>
            </div>
        </div>
        <div class="fc-button-group fc custom-buttons configure" style="top:71px !important;">
            <button *ngIf="!vm.googleCalendarFeatureDisabled && !vm.googleCalendarIntegrated"
                    class="fc-button save" id="calendarIntegrateButton"
                    style="margin-right: 20px;"
                    (click)="vm.showModalNotification()">
                {{ 'Calendar.Button.Integrate_Google_Calendar' | translate }}
            </button>
            <button *ngIf="vm.googleCalendarFeatureDisabled || !vm.googleCalendarIntegrated"
                    class="fc-button save"
                    id="calendarConfigureButton"
                    (click)="vm.toConfigure()">
                {{ 'Calendar.Button.Configure' | translate }}
            </button>
        </div>
        <ui-calendar id="cal" class="stb-schedule--calendar stb-schedule--compact" 
        	[calendarId]="'scheduleCalendar'"
        	(calendarWatchEvent)="vm.extraEventSignature"
            [uiConfig]="vm.uiConfig.calendar"
            [eventSources]="events"></ui-calendar>
    </md-card>
</div>
